export const SET_UBEREAT_RESTAURANTS = 'SET_UBEREAT_RESTAURANTS'
export const SET_UBEREAT_RESTAURANTS_TOTAL_LENGTH = 'SET_UBEREAT_RESTAURANTS_TOTAL_LENGTH'
export const SET_UBEREAT_RESTAURANT = 'SET_UBEREAT_RESTAURANT'
export const APPEND_UBEREAT_RESTAURANTS = 'APPEND_UBEREAT_RESTAURANTS'
export const SET_UBEREAT_RESTAURANTS_SHOW_ERROR_MODAL = 'SET_UBEREAT_RESTAURANTS_SHOW_ERROR_MODAL'
